import { format, addDays, startOfWeek, addWeeks } from 'date-fns';

export const getWeekStart = (date) => {
  // Get Monday of the week
  return startOfWeek(date, { weekStartsOn: 1 });
};

export const addWeeksToDate = (date, weeks) => {
  return addWeeks(date, weeks);
};

export const addDaysToDate = (date, days) => {
  return addDays(date, days);
};

export const formatDateKey = (date) => {
  return format(date, 'yyyy-MM-dd');
};

export const formatDayName = (date) => {
  return format(date, 'EEE');
};

export const formatShortDate = (date) => {
  return format(date, 'MMM d');
};

export const formatDateRange = (startDate, endDate) => {
  return `${format(startDate, 'MMM d')} - ${format(endDate, 'MMM d, yyyy')}`;
};

// Generate 14 dates for Mon-Sun over 2 weeks
export const generateDates = (startDate) => {
  const dates = [];
  let current = new Date(startDate);

  for (let week = 0; week < 2; week++) {
    for (let day = 0; day < 7; day++) { // Mon-Sun (7 days)
      dates.push(new Date(current));
      current = addDays(current, 1);
    }
  }

  return dates;
};

// Group jobs by date key
export const groupJobsByDate = (jobs) => {
  return jobs.reduce((acc, job) => {
    const dateKey = job.date.split('T')[0];
    if (!acc[dateKey]) acc[dateKey] = [];
    acc[dateKey].push(job);
    return acc;
  }, {});
};

// Move job in local state (optimistic update)
export const moveJobInState = (jobs, jobId, oldDateKey, newDateKey) => {
  const newJobs = { ...jobs };

  // Find and remove job from old date
  const jobIndex = (newJobs[oldDateKey] || []).findIndex(j => j.id.toString() === jobId);
  if (jobIndex === -1) return jobs;

  const [movedJob] = newJobs[oldDateKey].splice(jobIndex, 1);

  // Update job's date and mark as changed
  movedJob.date = newDateKey;
  movedJob.has_changes = true;

  // Add to new date
  if (!newJobs[newDateKey]) newJobs[newDateKey] = [];
  newJobs[newDateKey].push(movedJob);

  // Sort by school name
  newJobs[newDateKey].sort((a, b) => (a.school_name || '').localeCompare(b.school_name || ''));

  return newJobs;
};
